let recaptchaLoadPromise = null;

function loadRecaptchaScript() {
  if (window.grecaptcha) {
    return Promise.resolve();
  }
  if (!window.RECAPTCHA_SITE_KEY) {
    return Promise.reject(new Error('reCAPTCHA site key missing'));
  }
  if (!recaptchaLoadPromise) {
    recaptchaLoadPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${window.RECAPTCHA_SITE_KEY}`;
      script.async = true;
      script.onload = resolve;
      script.onerror = () => {
        recaptchaLoadPromise = null;
        reject(new Error('reCAPTCHA failed to load'));
      };
      document.head.appendChild(script);
    });
  }
  return recaptchaLoadPromise;
}

function getRecaptchaToken(action) {
  return loadRecaptchaScript().then(
    () =>
      new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(window.RECAPTCHA_SITE_KEY, { action })
            .then(resolve)
            .catch(reject);
        });
      })
  );
}

function initRecaptchaPreload() {
  const preload = () => {
    loadRecaptchaScript().catch(() => {});
  };
  document.addEventListener('focusin', (event) => {
    if (event.target.closest && event.target.closest('form[data-recaptcha-action]')) {
      preload();
    }
  });
  document.addEventListener('show.bs.modal', (event) => {
    if (event.target.querySelector && event.target.querySelector('form[data-recaptcha-action]')) {
      preload();
    }
  });
}

function setRecaptchaResponseInput(form, token) {
  let input = form.querySelector('input[name="g-recaptcha-response"]');
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'g-recaptcha-response';
    form.appendChild(input);
  }
  input.value = token;
  return input;
}

function initRemoteForm(formId, resetForm = true) {
  const form = document.getElementById(formId);
  const submitHandler = (event) => handleRemoteFormSubmit(event, form, resetForm);
  form.removeEventListener("submit",  submitHandler);
  form.addEventListener("submit",  submitHandler);
}

function initForm(formId) {
  const form = document.getElementById(formId);
  const submitHandler = (event) => handleFormSubmit(event, form);
  form.removeEventListener("submit",  submitHandler);
  form.addEventListener("submit",  submitHandler);
}

async function handleRemoteFormSubmit(event, form, resetForm = true) {
  event.preventDefault();
  const button = form.querySelector(".btn-submit");
  const successAlert = form.querySelector(".alert--success");
  const dangerAlert = form.querySelector(".alert--danger");
  button.disabled = true;

  const recaptchaAction = form.dataset.recaptchaAction;
  const formData = new FormData(form);
  if (recaptchaAction) {
    try {
      const token = await getRecaptchaToken(recaptchaAction);
      formData.set('g-recaptcha-response', token);
    } catch (e) {
      showAlert(dangerAlert, "Nastala chyba při odesílání formuláře.", 'danger');
      button.disabled = false;
      return;
    }
  }

  // Get the endpoint URL from the form's action attribute
  const endpointUrl = form.action;
  // AJAX request using the form's action URL
  fetch(endpointUrl, {
    method: 'POST',
    body: formData,
  })
    .then(response => response.json())
    .then(data => {
      if (data.result === "success") {
        showAlert(successAlert, data.msg || "Formulář úspěšně odeslán!", 'success');
        if (resetForm) {
          form.reset();
        }
      } else {
        showAlert(dangerAlert, data.msg || "Nastala chyba při odesílání formuláře.", 'danger');
      }
    })
    .catch(() => {
      showAlert(dangerAlert, "Nastala chyba při odesílání formuláře.", 'danger');
    })
    .finally(() => {
      setTimeout(() => {
        button.disabled = false;
      }, 2000);
    });
}

async function handleFormSubmit(event, form) {
  event.preventDefault();
  const button = form.querySelector(".btn-submit");
  button.disabled = true;

  const recaptchaAction = form.dataset.recaptchaAction;
  if (recaptchaAction) {
    try {
      const token = await getRecaptchaToken(recaptchaAction);
      setRecaptchaResponseInput(form, token);
    } catch (e) {
      button.disabled = false;
      return;
    }
  }

  form.submit();
}

function showAlert(element, message) {
  element.innerHTML = message;
  element.classList.remove("d-none");
  setTimeout(() => {
    element.classList.add("d-none");
  }, 5000);
}

document.addEventListener("DOMContentLoaded", function(event) {
  initRecaptchaPreload();
  if (document.getElementById("user-password-reset-form")) {
    initRemoteForm('user-password-reset-form');
  }
  if (document.getElementById("offer-message-form")) {
    initRemoteForm('offer-message-form');
  }
  if (document.getElementById("report-message-form")) {
    initRemoteForm('report-message-form');
  }
  if (document.getElementById("vin-message-form")) {
    initRemoteForm('vin-message-form');
  }
  if (document.getElementById("question-message-form")) {
    initRemoteForm('question-message-form');
  }
  if (document.getElementById("user-signin-form")) {
    initForm('user-signin-form');
  }
  if (document.getElementById("user-profile-form")) {
    initRemoteForm('user-profile-form', false);
  }
  if (document.getElementById("sticker-request-form")) {
    initRemoteForm('sticker-request-form');
  }
  if (document.getElementById("extra-request-form")) {
    initRemoteForm('extra-request-form');
  }
  if (document.getElementById("premium-request-form")) {
    initRemoteForm('premium-request-form');
  }
  if (document.getElementById("import-message-form")) {
    initRemoteForm('import-message-form');
  }
  if (document.getElementById("insurance-request-form")) {
    initRemoteForm('insurance-request-form');
  }
  if (document.getElementById("financing-request-form")) {
    initRemoteForm('financing-request-form');
  }
  if (document.getElementById("call-request-form-financing")) {
    initRemoteForm('call-request-form-financing');
  }
  if (document.getElementById("call-request-form-insurance")) {
    initRemoteForm('call-request-form-insurance');
  }
});
